export const cubicBezierFunction = 'cubic-bezier(0.87, 0, 0.13, 1)'

const transitionEase400 = `all 400ms ${cubicBezierFunction}`

export const defaultStyle = {
  opacity: 1,
  transition: transitionEase400,
}
export const sideNavTransition: any = {
  entering: {
    width: '72px',
  },
  entered: {
    width: '312px',
    transition: `all 500ms ${cubicBezierFunction}`,
  },
  exiting: {
    width: '312px',
  },
  exited: {
    width: '72px',
    transition: `all 500ms ${cubicBezierFunction}`,
  },
}

export const childTransition: any = {
  entered: {
    opacity: 1,
    transform: 'translateX(0%)',
    transition: `opacity 600ms ${cubicBezierFunction}`,
  },
  entering: {
    opacity: 0,
    transform: 'translateX(-100%)',
  },
  exiting: {
    opacity: 1,
    transition: `opacity 100ms ${cubicBezierFunction}`,
    transform: 'translateX(-150%)',
  },
  exited: {
    opacity: 1,
    transition: `all 1500ms ${cubicBezierFunction}`,
  },
}
